/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-26 23:01:00
 * @FilePath: /unifyxp-v2-store-portal/src/components/CloneButton/index.tsx
 */
import React from 'react';
import { Button } from 'src/components/Antd';
import css from './css.module.less';
import { modal } from 'src/utils/Modal';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const CloneBtn = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { onClick, className, btnClassName, avoidAlert, disabled } = props;
  const handleOnClick = () => {
    if (avoidAlert) {
      if (onClick) {
        onClick();
      }
      return;
    }
    modal.error({
      title: getI18n('general.cloneBtn.error_title'),
      content: getI18n('general.cloneBtn.error_content'),
      onOkText: getI18n('general.confirm'),
      onCancel: () => {
        return;
      },
      onCancelText: getI18n('general.cancel'),
      onOk: onClick,
    });
  };
  return (
    <div className={`${css.container} ${className || ''}`}>
      <Button
        disabled={disabled}
        className={`${css.btn} ${btnClassName || ''}`}
        type='primary'
        onClick={handleOnClick}>
        {props.buttonText || getI18n('general.cloneBtn.error_title')}
      </Button>
    </div>
  );
};
export default CloneBtn;
